/** One error toast for facet ops: plan-cap 403s get an Upgrade action. */
import { apiErrorDetail, isUpgradeRequired } from "@/lib/api-error";
import { toast } from "@/lib/toast";

export async function toastFacetError(err: unknown, fallback: string, goToBilling: () => void): Promise<void> {
  const detail = await apiErrorDetail(err, fallback);
  if (await isUpgradeRequired(err)) {
    toast.error(detail, { action: { label: "Upgrade", onClick: goToBilling } });
  } else {
    toast.error(detail);
  }
}
